import styles from "./category.module.css";
import IndeterminateCheckbox from "./indeterminate-checkbox";

export default ({ category, checked, onCheckedChange }) => {
    if (!category) { return <p>error</p> }
    return (
        <div
            style={{
                borderColor: category.color,
                backgroundColor: `${category.color}11`,
                opacity: checked ? 1 : 0.3
            }}
            onClick={onCheckedChange ? () => onCheckedChange(checked === null ? false : !checked) : null}
            className={styles.category}
        >
            {onCheckedChange &&
                <IndeterminateCheckbox
                    checked={checked}
                    onChange={e => onCheckedChange(e.target.checked)}
                />
            }
            <span>{category.name}</span>
        </div>
    );
};
